import styled, { css } from 'styled-components';

type StatusProps = {
    rightPos?: string;
    inList?: boolean;
    inButton?: boolean;
    inTab?: boolean;
};

export const StatusIcon = styled.span<StatusProps>`
    font-weight: 500;
    font-size: 0.75rem;
    position: absolute;
    padding: 2px 0;
    border-radius: 50%;
    height: 18px;
    width: 18px;
    font-size: 9px;
    right: 0;
    text-align: center;

    ${(props) =>
        props.inButton &&
        css`
            right: 2px;
            bottom: 2px;
            font-size: 9px;
            padding: 2px;
            height: 16px;
            width: 16px;
        `}

    ${(props) =>
        props.rightPos &&
        css`
            right: ${props.rightPos};
        `}

    &.status-unsaved {
        color: #333;
        background: #fff;
    }
    &.status-draft {
        color: #333;
        background: #ccc;
    }
    &.status-sent-to-operator {
        color: #fff;
        background: #f5ab23;
    }
    &.status-canceled {
        color: #fff;
        background: black;
    }
    &.status-ordered {
        color: #223804;
        background: #c4dfa0;
    }
    &.status-confirmed {
        color: #fff;
        background: #107c10;
    }
    &.status-has-reported-rob {
        color: #fff;
        background: #107c10;
    }
    &.status-has-missing-rob {
        color: #fff;
        background: orangered;
    }
`;

export const UpdateStatusIcon = styled.span<StatusProps>`
    ${(props) =>
        props.inList &&
        css`
            right: 28px;
            bottom: -15px;
            position: absolute;
            padding: 0;
        `}

    ${(props) =>
        props.inTab &&
        css`
            right: 0;
            bottom: 0;
            position: absolute;
        `}

    padding: 0 3px 0 0;
    font-weight: 500;
    font-size: 0.75rem;

    &.updated-by-ship {
        color: #f5ab23;
    }
    &.updated-by-operator {
        color: orangered;
        bottom: -3px;
        left: 0;
    }
`;
